import React from 'react';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TContentCardsProps = {
  kind?: 'grid';
  className?: string;
  children?: React.ReactNode;
};

const ContentCards = ({ kind, ...rest }: TContentCardsProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return <Box {...rest} {...conditionalProps} as="section" name="ContentCards" />;
};

export default ContentCards;
